import Api from "../api";

class SearchEngine {
  addSearchEngine = async (data) => {
    const { body } = await Api.post("searchEngine", data);
    return body;
  };

  fetchSearchEngine = async (id) => {
    const { body } = await Api.get(`searchEngine/${id}`);
    return body;
  };

  updateSearchEngine = async (id, data, params = {}) => {
    const { body } = await Api.put(`searchEngine/${id}`, data, params);
    return body;
  };

  fetchSearchEngines = async (
    params = { order_by: "id", order_direction: "ASC" }
  ) => {
    const { body } = await Api.get(`searchEngines`, null, params);
    return body;
  };

  deleteSearchEngine = async (id, params = {}) => {
    const { body } = await Api.destroy(`searchEngine/${id}`, {}, params);
    return body;
  };
}
// eslint-disable-next-line
export default new SearchEngine();
